export const AdminOnlineCertificates = {
  en: {
    'Online Certificates': 'Online Certificates',
    'Create Online Certificate': 'Create Online Certificate',
    Name: 'Name',
    Active: 'Active',
    Price: 'Price',
    Services: 'Services',
  },
  uk: {
    'Online Certificates': 'Онлайн Сертифікати',
    'Create Online Certificate': 'Створити онлайн сертифікат',
    Name: 'Назва',
    Active: 'Активний',
    Price: 'Ціна',
    Services: 'Сервіси',
  },
};

export const AdminOnlineCertificateForm = {
  en: {
    ...AdminOnlineCertificates.en,
    'New Online Certificate': 'New Online Certificate',
    'Edit Online Certificate': 'Edit Online Certificate',
    Description: 'Description',
    'Choose services for the online certificate':
      'Choose services for the online certificate',
  },
  uk: {
    ...AdminOnlineCertificates.uk,
    'New Online Certificate': 'Новий онлайн сертифікат',
    'Edit Online Certificate': 'Редагування онлайн сертифікату',
    Description: 'Опис',
    'Choose services for the online certificate':
      'Виберіть сервіси для онлайн сертифікату',
  },
};
